import { RichTextValue } from "@xapp/chat-widget-core";
import React, { FC, useCallback } from "react";
import { useSearchStore } from "../../store";
import { SearchInput, SearchInputProps } from "./SearchInput";

export type SearchInputContainerProps = Omit<SearchInputProps, "value" | "onChange">;

export const SearchInputContainer: FC<SearchInputContainerProps> = props => {
    const [state, dispatch] = useSearchStore();

    const { query } = state;

    const handleQueryChange = useCallback((value: RichTextValue) => {     
        dispatch({
            type: "set-query",
            query: value
        })
    }, [dispatch]);

    return (
        <SearchInput
            {...props}
            value={query}
            onChange={handleQueryChange}
        />
    );
};